import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-ibmcognos',
  standalone: false,
  templateUrl: './ibmcognos.component.html',  
  styleUrls: ['./ibmcognos.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IbmcognosComponent { }
